import Loader from '../../Components/Loader';
import Loadable from 'react-loadable';

const LoadableNewsList = Loadable({
  loader: () => import('../NewsContainer/containers/NewsListContainer'),
  loading: Loader,
  delay: 400 // 0.3 seconds
});

export default LoadableNewsList;
